import { useMemo } from "react";
import { useMediaQuery, useResponsive } from "./use-responsive";

export const useResponsiveTileHeight = (isMobileView: boolean) => {
  const is2xl = useMediaQuery("(min-width: 1440px)"); // >1440
  const isXl = useResponsive("up", "xl"); // >1280
  const isLg = useResponsive("up", "lg"); // >1024
  const isMd = useResponsive("up", "md"); // >768


  const height = useMemo(() => {
    if (isMobileView) return 46.66;
    if (is2xl) return 53;
    if (isXl) return 53;
    if (isLg) return 70;
    if (isMd) return 70;
    return 46.66; // <768
  }, [isMobileView, is2xl, isXl, isLg, isMd]);

  return height;
};
